import { render, staticRenderFns } from "./ExhibitionWarehouse.vue?vue&type=template&id=b9f60524"
import script from "./ExhibitionWarehouse.vue?vue&type=script&lang=js"
export * from "./ExhibitionWarehouse.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports